import { INVOICE_STATUS_LABEL, INVOICE_STATUS_TONE } from '../../Enums/stripe-status.enum';
import { InvoiceSummaryResponse } from '../../Interfaces/api/backoffice/billing-document.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class InvoiceSummary {
  id = '';
  stripe_invoice_id: string | null = null;
  stripe_status = '';
  display_status: string | null = null;
  plan_name: string | null = null;
  currency: string | null = null;
  subtotal: number | null = null;
  tax: number | null = null;
  total: number | null = null;
  period_start: string | null = null;
  period_end: string | null = null;
  issued_at: string | null = null;
  paid_at: string | null = null;
  seat_quantity: number | null = null;
  device_quantity: number | null = null;
  attempt_count = 0;

  constructor(data: Partial<InvoiceSummaryResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return INVOICE_STATUS_LABEL[this.stripe_status] ?? this.stripe_status;
  }

  get statusTone(): StatusTone {
    return INVOICE_STATUS_TONE[this.stripe_status] ?? 'neutral';
  }

  get needsAttention(): boolean {
    return this.stripe_status === 'open' || this.stripe_status === 'uncollectible';
  }
}
